  <template >
   <div class="formPosition" v-role="'prof'">
      <v-progress-linear  style="margin : 0 auto ; height:10px" indeterminate v-if="isLoading"></v-progress-linear>

     <template>
  <v-container class="grey lighten-5">
    <v-row no-gutters>
      <v-col md="8">
         <span> - Escolhe a classe </span>

                 <v-icon large color="green darken-2">forward</v-icon>

<div class="text-center">

    <v-btn @click="classe(1)" class="ma-2" outlined color="indigo"><v-icon  small color="primary" >filter_1</v-icon> 10ª classe</v-btn>
    <v-btn @click="classe(2)" class="ma-2" outlined color="indigo"><v-icon  small  color="primary" >filter_2</v-icon> 11ª classe</v-btn>
    <v-btn @click="classe(3)" class="ma-2" outlined color="indigo"><v-icon  small  color="primary" >filter_3</v-icon> 12ª classe</v-btn>
    <v-btn @click="classe(4)"
     class="ma-2" outlined color="indigo"><v-icon  small  color="primary" >filter_4</v-icon> 13ª classe</v-btn>
  </div>
      </v-col>
     <v-col md="2">
             <v-select
              :items="Listaranoslectivo"
              v-model="anolectivoSelected"
              item-value="descricao"
              item-text="novadescricao"
              @change="FiltrarAnolectivo()"
              label="Selecione o Ano lectivo"
              return-object
            ></v-select>
      </v-col>
       <v-col md="1">
        <v-btn to="/impressao/menu" color="blue" fab small> <v-icon small color="white">arrow_back</v-icon> </v-btn >
      </v-col>
    </v-row>
  </v-container>
  </template>
   </div>
</template>

<script>
import axios from '../../plugins/axios'
const ls = require('local-storage')
export default {

  data: () => ({
    anolectivoSelected: ls.get('anolectivo'),
    Listaranoslectivo: [],
    isLoading: false,
    iskilamba: false
  }),

  computed: {

    idclasse () {
      return this.$store.state.idclasse
    }
  },

  created () {
    this.initializeAnosLectivo()
    // Seta o anolectivo padrão
    if (ls.get('role') === 'ROLE_COOR') { this.roles = 'coor' }
    this.$store.state.anolectivoSelecionado = this.anolectivoSelected
    this.$store.state.novadescricaoSelecionado = ls.get('novadescricao')
    if (window.location.host.includes('localhost')) {
      this.iskilamba = true
    } else if (window.location.host.includes('eftsk')) {
      this.iskilamba = true
    } else if (window.location.host.includes('eftsl')) {
      this.iskilamba = false
    }
  },

  methods: {
    classe (idclasse) {
      let a = parseInt(this.$store.state.anolectivoSelecionado)
      const ls = require('local-storage')
      this.$store.state.idclasse = idclasse
      if (idclasse === 1) {
        this.$store.state.classeTur = '10ªC-' + ls.get('anolectivo')
      } else if (idclasse === 2) {
        this.$store.state.classeTur = '11ªC-' + ls.get('anolectivo')
      } else if (idclasse === 3) {
        this.$store.state.classeTur = '12ªC-' + ls.get('anolectivo')
      } else if (idclasse === 4) {
        this.$store.state.classeTur = '13ªC-' + ls.get('anolectivo')
      }

      if (false) {
        if (a >= 2020) {
          this.$router.push('pauta_geral24_2020')
        } else { this.$router.push('pautageral_24') }
      } else {
        if (a >= 2020) {
          this.$router.push('pauta_geral')
        } else { this.$router.push('imprimir-pauta') }
      }
    },

    async initializeAnosLectivo () {
      this.isLoading = true
      try {
        this.Listaranoslectivo = await axios
          .get('/listarAnoLectivoAll')
          .then(res => res.data)
      } catch (error) {
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      } finally {
        this.isLoading = false
      }
    },

    FiltrarAnolectivo () {
      this.$store.state.anolectivoSelecionado = this.anolectivoSelected.descricao
      this.$store.state.novadescricaoSelecionado = this.anolectivoSelected.novadescricao
    }
  }
}
</script>
